import { TranslationChunksConfig, TranslationResources } from '@spartacus/core';
import { en } from './en';
import { frCA } from './fr-CA';

export const knbrProductTranslations: TranslationResources = { en, fr_CA: frCA };

export const knbrProducTranslationChunksConfig: TranslationChunksConfig = {
  knbrProduct: [
    'stockNotification',
    'addToWishList',
    'variant',
    'TabPanelContainer',
    'addToCart',
    'productReview',
    'productSummary',
    'productFacetNavigation',
    'productList',
    'productDetails',
    'KnBrCMSTabParagraphContainer',
    'knBrSearchBox',
  ],
};
